import { spawn } from 'node:child_process'
import fs from 'node:fs'
import path from 'node:path'
import { buildSeedScript } from '../seed/build-seed-script.js'

export function runSeedScript(
  cwd: string,
  adminDir: string,
  authBasePath: string,
  envOverrides: NodeJS.ProcessEnv
): Promise<{
  code: number | null
  stdout: string
  stderr: string
  timeout: boolean
  spawnError?: string
}> {
  const scriptsDir = path.join(cwd, adminDir, 'scripts')
  const seedPath = path.join(scriptsDir, 'seed.ts')

  if (!fs.existsSync(scriptsDir)) {
    fs.mkdirSync(scriptsDir, { recursive: true })
  }
  fs.writeFileSync(seedPath, buildSeedScript(authBasePath), 'utf-8')

  const cleanup = () => {
    try {
      fs.unlinkSync(seedPath)
      if (fs.existsSync(scriptsDir) && fs.readdirSync(scriptsDir).length === 0) {
        fs.rmdirSync(scriptsDir)
      }
    } catch {}
  }

  return new Promise((resolve) => {
    const tsxBin = path.join(cwd, 'node_modules', '.bin', 'tsx')
    const child = spawn(tsxBin, [seedPath], {
      cwd,
      stdio: 'pipe',
      env: {
        ...process.env,
        ...envOverrides
      }
    })
    let stdout = ''
    let stderr = ''
    child.stdout?.on('data', (chunk: Buffer) => {
      stdout += chunk.toString()
    })
    child.stderr?.on('data', (chunk: Buffer) => {
      stderr += chunk.toString()
    })
    const timeout = setTimeout(() => {
      child.kill()
      cleanup()
      resolve({ code: null, stdout, stderr, timeout: true })
    }, 30_000)
    child.on('close', (code) => {
      clearTimeout(timeout)
      cleanup()
      resolve({ code, stdout, stderr, timeout: false })
    })
    child.on('error', (err) => {
      clearTimeout(timeout)
      cleanup()
      resolve({ code: null, stdout, stderr, timeout: false, spawnError: err.message })
    })
  })
}
